/**
 * @param props.color : a hex color to set stroke or fills color of svg path
 * @param props.size : set the icon size, see getSize for expected values
 * @param props.className : a tailwind class the would be implemented on span tag
 */

interface PersonProps {
  color?: string
  size?: string
  className?: string
}

const IconHome = (props: PersonProps) => {
  const { className = '', color = '#364152' } = props

  return (
    <span className={'flex items-center justify-center' + className}>
      <svg
        width={18}
        height={18}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.33333 17V10.9136C6.33333 10.3534 6.8109 9.89923 7.4 9.89923H10.6C11.1891 9.89923 11.6667 10.3534 11.6667 10.9136V17M8.38184 1.18771L1.44851 5.87647C1.16713 6.06676 1 6.3748 1 6.70316V15.4784C1 16.3188 1.71634 17 2.6 17H15.4C16.2837 17 17 16.3188 17 15.4784V6.70316C17 6.3748 16.8329 6.06676 16.5515 5.87647L9.61816 1.18771C9.24807 0.937431 8.75193 0.93743 8.38184 1.18771Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </span>
  )
}

export default IconHome
